"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputNotEmpty = void 0;
/**
 * Validate any of the element in an array is null or not
 *
 * @param {string[]} input - The value to be formatted.
 * @returns {boolean} - If an array contain null value it will return false else will return true.
 */
const inputNotEmpty = (input) => {
    for (let i = 0; i <= input.length; i++) {
        if (input[i] === "") {
            return false;
        }
    }
    return true;
};
exports.inputNotEmpty = inputNotEmpty;
